import React from 'react';

import { Sizes, TypographyProps } from '../../types';
import { useTypography, makeFontSizes } from '../../utils';

import { Typography } from '../typography';

const fontsSizes = makeFontSizes<Sizes>({
  xxlarge: { base: 'font-size-70' },
  xlarge: { base: 'font-size-60' },
  large: {
    base: 'font-size-40',
    sm: 'font-size-50',
  },
  medium: { base: 'font-size-40' },
  small: { base: 'font-size-30' },
  xsmall: { base: 'font-size-20' },
  xxsmall: { base: 'font-size-10' },
});

export function Label({
  children,
  className,
  size,
  tag = 'p',
  weight = 'regular',
  casing = 'none',
  ...rest
}: TypographyProps<Sizes>): JSX.Element {
  const styles = useTypography({
    fontsSizes,
    size,
    casing,
    weight,
    lineHeight: 1.2,
  });

  return (
    <Typography className={className} styles={styles} as={tag} {...rest}>
      {children}
    </Typography>
  );
}
